import { setShowForm } from "./showFormSlice";

export const changeShowForm = setShowForm;
